export default __webpack_public_path__ + "static/media/files-o-dark.e8c07c35.svg";